import { FEATURES } from "types/landlord/partner";

/**
 * UI feature flag holding BSCPF-6947 back while it ships dark: Notifications
 * in the menu for every partner type, so Boom network rental verifications
 * (BSCPF-5344) reach partners without BoomScreen.
 *
 * A `ui_` registry flag (Boom::UiFeatureFlag): the key arrives in the
 * partner's `features` array and is toggled per partner from admin's
 * /ui-feature-flags page. A partner whose features have not loaded counts as
 * OFF.
 *
 * ──────────────────────────────────────────────────────────────────────────
 * REMOVING THE FLAG once it is on for everyone:
 *
 *  1. Drop `isNotificationsForAllPartners` and its calls (nav sections and
 *     `showsProductNotificationTabs` below); drop the flag-off tests.
 *  2. `types/landlord/partner.ts` — drop `UI_NOTIFICATIONS_ALL_PARTNERS`.
 *  3. Delete the `ui_notifications_all_partners` row in admin's
 *     /ui-feature-flags.
 */
export const isNotificationsForAllPartners = (
  partner: { features: FEATURES[] } | null | undefined
) =>
  Boolean(partner?.features.includes(FEATURES.UI_NOTIFICATIONS_ALL_PARTNERS));

// Applications, Mentions, Assigned and Communications belong to BoomScreen and
// BoomCRM. A partner with neither gets Rental verifications only (BSCPF-6947);
// the API keeps the hidden tabs' kinds out of its list and unread badge
// (Notification.visible_kinds_for).
export const showsProductNotificationTabs = (
  type: { isBoomScreen: boolean; isBoomCRM: boolean },
  partner: { features: FEATURES[] } | null | undefined
) =>
  type.isBoomScreen ||
  type.isBoomCRM ||
  !isNotificationsForAllPartners(partner);
